<div id="">
  <header id="banner" role="banner">
     <nav class="site-breadcrumbs" id="breadcrumbs">
        <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
        <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
         <li class="first"><span><a routerLink="">SIRA</a></span></li>
         <li><span><a href="/sirang/datiaperti">DATI APERTI</a></span></li>
         <li class="last"><span><a href="/sirang/datiaperti/elenchi"></a>ELENCHI</span></li>
     </ul>
     </nav>
  </header>
  <div id="content">
     <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
        <span id="p_103"></span> 
        <div class="portlet-body"> </div>
     </div>
     <div class="columns-2" id="main-content" role="main">
        <div class="portlet-layout" id="aui_3_4_0_1_591">
           <div class="aui-w70 portlet-column" id="column-1">
              <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                 <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H7pGyMq5rlnM_">
                    <span id="p_56_INSTANCE_H7pGyMq5rlnM"></span> 
                    <div class="portlet-body" id="aui_3_4_0_1_590">
                       <section class="portlet" id="portlet_56_INSTANCE_H7pGyMq5rlnM">
                          <table style="width: 100%;">
                             <tbody>
                                <tr>
                                   <td>
                                      <header class="portlet-topper gradient">
                                         <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Elenchi e albi</span> </h1>
                                      </header>
                                   </td>
                                </tr>
                             </tbody>
                          </table>
                          <div class="portlet-content" id="aui_3_4_0_1_589">
                             <div class=" portlet-content-container" style="" id="aui_3_4_0_1_588">
                                <div class="portlet-body" id="aui_3_4_0_1_587">
                                   <div class="journal-content-article" id="aui_3_4_0_1_586">
                                      <p>
                                       In questa sezione è possibile accedere agli elenchi ed albi di interesse ambientale senza autenticazione. Tra gli elenchi accessibili è presente quello relativo ai Centri di educazione ambientale, all’interno del quale è possibile prendere visione dei dati specifici di ogni centro dedicato all’educazione ambientale.
                                      </p>
                                      <br/>
                                      <b>Elenchi e Albi pubblici</b>
                                      <br/><br/>
                                      <ul>
                                       <li>
                                          <a href="https://test.sardegnasira.it/GPAtools/flow/elenchiealbi?idAlbo=369" target="_blank">Elenco Centri di Educazione Ambientale e alla Sostenibilità Accreditati (CEAS)</a>
                                       </li>
                                       <li>
                                          <a href="https://test.sardegnasira.it/GPAtools/flow/elenchiealbi?idAlbo=382" target="_blank">Elenco degli osservatori astronomici e astrofisici statali</a>
                                       </li>
                                       <li>
                                          <a href="https://test.sardegnasira.it/GPAtools/flow/elenchiealbi?idAlbo=-4" target="_blank">Elenco organizzazioni registrate EMAS</a>
                                       </li>
                                       <li>
                                          <a href="https://test.sardegnasira.it/GPAtools/flow/elenchiealbi?idAlbo=452" target="_blank">Elenco regionale dei certificatori energetici</a>
                                       </li>
                                       <li>
                                          <a href="https://www.regione.sardegna.it/documenti/1_38_20130130174606.pdf" target="_blank">Registro Regionale delle Guide Ambientali Escursionistiche (GAE)</a>
                                       </li>
                                    </ul>
                                   </div>
                                </div>
                             </div>
                          </div>
                       </section>
                    </div>
                 </div>
              </div>
           </div>
           <div class="aui-w30 portlet-column" id="column-2">
              <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                 <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_RxuFFVEU5ofT_">
                    <span id="p_56_INSTANCE_RxuFFVEU5ofT"></span> 
                    <div class="portlet-body">
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</div>